import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';

import { xboxAvailable } from 'Helpers/Geo/data';

export default function AccessibilityMenu({ menuLinks, from }) {
  return (
    <nav aria-label={`${from} mega menu`} className="AccessibilityMenu">
      <ul role="menubar">
        {menuLinks.map((menuLink) => {
          if (menuLink.tabId === 'xboxgames' && (!xboxAvailable || isEmpty(menuLink.products))) return false;
          if (menuLink.tabId === 'recommendations') return false;
          if ((menuLink.tabId === 'featured' || menuLink.tabId === 'featuredSecond' || menuLink.tabId === 'stardeal') && isEmpty(menuLink.product)) return false;

          return (
            <li role="none" key={menuLink.tabId}>
              {menuLink.link ?
                <Link role="menuitem" to={menuLink.link}>
                  {menuLink.name}
                </Link>
                :
                <>
                  {menuLink.name}
                </>
              }

              {menuLink.product &&
                <ul role="menu">
                  <li role="none">
                    <Link role="menuitem" to={`/${menuLink.product.type}/${menuLink.product.slug}`}>
                      {menuLink.product.name}
                    </Link>
                  </li>
                </ul>
              }

              {menuLink.products &&
                <ul role="menu">
                  {menuLink.products.map(p =>
                    <li role="none" key={p.slug}>
                      <Link role="menuitem" to={`/${p.type}/${p.slug}`}>
                        {p.name}
                      </Link>
                    </li>,
                  )}
                </ul>
              }
            </li>
          );
        },
        )}
      </ul>
    </nav>
  );
}

AccessibilityMenu.propTypes = {
  menuLinks: PropTypes.arrayOf(PropTypes.object),
  from: PropTypes.string,
};

AccessibilityMenu.defaultProps = {
  menuLinks: [],
  from: '',
};
